import { render, staticRenderFns } from "./ETHToken.vue?vue&type=template&id=1700bb5e&scoped=true&"
import script from "./ETHToken.vue?vue&type=script&lang=js&"
export * from "./ETHToken.vue?vue&type=script&lang=js&"
import style0 from "./ETHToken.vue?vue&type=style&index=0&id=1700bb5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1700bb5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
